<ion-header>
  <app-page-header popoverCssClass='lesson-plans'></app-page-header>
  
  <div class='top'>
    <div class='contents'>
      <div class='left'>
        <button class='course-selector' (click)='chooseCourseType($event)'>{{courseType}}<i class='mt-arrow-down'></i></button>
        <button class='add' (click)='addNewCourse()'><i [ngClass]="newCourse ? 'mt-minus' : 'mt-plus'" ></i></button>
      </div>
      
      <div class='right'>
        <div class='sort'>
          <label>Sort By</label>
          <button (click)='chooseSortType($event)'>{{sortType}}</button>
        </div>
        <div class='search'>
          <label>Search</label>
          <input placeholder='Name, Type, or Semester' [(ngModel)]='searchText'>
        </div>
        <button class='add' (click)='addNewCourse()'><i [ngClass]="newCourse ? 'mt-minus' : 'mt-plus'" ></i></button>
      </div>

      <div class='shield' [hidden]='!shouldShowWelcome() || !newCourse'></div>
    </div>

    <div class='welcome' [hidden]='!shouldShowWelcome()'>
      <img src='assets/friends/Friends-welcomescreen1.gif'>
      <h1>Welcome, {{teacher?.user?.name}}</h1>
      <img src='assets/friends/Friends-welcomescreen2.gif'>
    </div>
 
    <div [ngClass]="['bar', courseCssService.responsiveClass()]" [hidden]='true || shouldShowWelcome()'>
      <div class='buttons'>
        <div [ngClass]="['button-list', courseCssService.responsiveClass()]">
          <button class='collection-column' (click)='sortyByCollection()'>Collection</button>
          <button class='semester-column' (click)='sortyByDate()'>Semester Start Date</button>
          <button class='type-column' (click)='sortyByClassType()'>Class Type</button>
        </div>
      </div>
    </div>
  </div>
</ion-header>

<ion-content appScrollBounce>
  <div class='middle'>
    <div class='courses'>
      <ng-container *ngIf='newCourse !== null'>
        <app-course-header-edit [course]='newCourse' (save)='saveNewCourse($event)' (cancel)='cancelNewCourse()' [resources]='resources' [teacher]='teacher'></app-course-header-edit>
        <div class='new-course-instructions'>
          <p>Fill in the fields above to create a semester for your lesson plans.</p>
        </div>
      </ng-container>

      <ng-container *ngFor='let course of courses; trackBy: trackByCourseUuid'>
        <app-course [course]='course' [resources]='resources' [teacher]='teacher' (courseArchiveAction)='courseArchiveAction()'></app-course>
      </ng-container>
    </div>
  </div>
</ion-content>